<template>
  <v-card variant="outlined" class="pa-3">
    <h4 class="text-subtitle-2 mb-2">{{ $t("apiManager.shapefile") }}</h4>
    <span class="d-flex justify-center">
      <v-btn
        block
        color="primary"
        class="mb-2"
        size="small"
        :class="{ 'rtl-btn': $i18n.locale === 'he' }"
        @click="requestShapefileContentHandler"
        :loading="loadingShapefile"
      >
        <v-icon class="mr-2">mdi-download</v-icon>
        {{ $t("apiManager.requestShapefile") }}
      </v-btn>
    </span>
    <v-tooltip :disabled="isVersionValid" location="top">
      <template #activator="{ props }">
        <span v-bind="props" class="d-flex justify-center">
          <v-btn
            block
            color="secondary"
            class="mb-2 update-version"
            size="small"
            :class="{ 'rtl-btn': $i18n.locale === 'he' }"
            @click="updateShapefileVersionHandler"
            :loading="loadingVersion"
            :disabled="!isVersionValid"
          >
            <v-icon class="mr-2">mdi-update</v-icon>
            {{ $t("apiManager.updateVersion") }}
          </v-btn>
        </span>
      </template>
      <span :dir="$i18n.locale === 'he' ? 'rtl' : 'ltr'">{{
        versionError
      }}</span>
    </v-tooltip>
    <div class="d-flex justify-center">
      <v-text-field
        v-model="shapefileVersion"
        :label="$t('apiManager.version')"
        dense
        outlined
        hide-details
        class="mb-2"
        :class="{ 'rtl-input': $i18n.locale === 'he' }"
      />
    </div>
    <v-alert
      v-if="shapefileRequestId"
      type="info"
      variant="tonal"
      class="mt-2 response-window"
      :class="{ 'rtl-alert': $i18n.locale === 'he' }"
    >
      <strong>{{ $t("apiManager.requestId") }}:</strong>
      <code class="request-id">{{ ' ' +  shapefileRequestId }}</code>
      <div class="mt-1 text-caption">
        {{ $t("apiManager.requestIdDescription") }}
      </div>
      <div class="mt-1 text-caption text-primary">
        <v-icon size="small" class="mr-1">mdi-information</v-icon>
        {{ $t("apiManager.switchedToShapefileTab") }}
      </div>
    </v-alert>
    <!-- Response Display (can be slotted or passed as prop) -->
    <slot name="response"></slot>
  </v-card>
</template>

<script>
export default {
  name: "ShapefileManager",
  props: {
    loadingShapefile: Boolean,
    loadingVersion: Boolean,
    shapefileRequestId: String,
    version: String,
    response: Object,
  },
  data() {
    return {
      shapefileVersion: this.version || "01.01.01",
    };
  },
  watch: {
    version(val) {
      this.shapefileVersion = val;
    },
  },
  computed: {
    isVersionValid() {
      // Accepts 1.0, 1.0.0, 12.34, 1.2.3, etc.
      return /^\d+\.\d+(\.\d+)?$/.test(this.shapefileVersion);
    },
    versionError() {
      if (!this.isVersionValid)
        return this.$t("apiManager.errorInvalidVersion");
      return "";
    },
  },
  methods: {
    requestShapefileContentHandler() {
      this.$emit("request-shapefile-content", this.shapefileVersion);
    },
    updateShapefileVersionHandler() {
      this.$emit("update-shapefile-version", this.shapefileVersion);
    },
  },
};
</script>